import {
  BaseAggregateCoachingData,
  BaseAggregateCoachingItemData,
} from "@readai/common/types";

export const DEFAULT_COACHING_ITEM_DATA: BaseAggregateCoachingItemData = {
  count: 0,
  moments: [],
  rate: null,
  sessions: [],
  words: [],
};

export const DEFAULT_COACHING_DATA: BaseAggregateCoachingData = {
  fillerWords: DEFAULT_COACHING_ITEM_DATA,
  interruptions: DEFAULT_COACHING_ITEM_DATA,
  nonInclusiveTerms: DEFAULT_COACHING_ITEM_DATA,
  questions: DEFAULT_COACHING_ITEM_DATA,
  talkingPace: DEFAULT_COACHING_ITEM_DATA,
};
